module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("P")])]), _vm._v("erched on the edge of a sofa in her ornately decorated drawing room, Lady Bodenham scrutinized the Duke of Deighton.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Well, cousin,” she observed with a maternal frown, “I must say the Italian air seems to agree with you, although you are quite brown.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She hit Galen’s arm with her delicate ivory fan at each word. “Really…” Tap. “Quite…” Tap. “Brown.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Fortunately, her thin limbs seemed utterly without muscle, so her blows were no more disturbing to him than a piece of goose down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Meanwhile, the Duke of Deighton’s notoriously sensual lips curved up into a smile and his hazel eyes, twinkling with wry humor, calmly returned her perusal.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("Eloise was as ornately decorated as the large room that had originally been part of a medieval ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("abbey. Her family had gained possession of the abbey during the reign of Henry the Eighth and had been renovating it ever since, some with better taste than others.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Tonight Eloise wore a much trimmed muslin empire-waisted gown of pale green that regrettably brought out the green tinge to her somewhat sallow complexion. Her hair, which had never been fulsome, was tortured into a complicated style that made Galen want to wince as he speculated on the damage it must be doing to the scalp beneath.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“No doubt you spent far too much time living like a peasant,” Eloise continued with a hint of petulance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Then I would have been a very wealthy and indolent peasant,” he replied. “Tell me, is that all the change you notice?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Why, what else should I see? A tattoo or something equally outrageous?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Galen didn’t know why he had bothered to ask. Eloise had never been noted for her perception.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("And as to his outward appearance, she was quite right. Save for tanned skin and a few wrinkles about the eyes, he didn’t look much different than when he left England ten years ago.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("He sighed as he turned his attention to Eloise’s many guests, the usual collection of friends and sycophants who enjoyed his cousin’s generous hospitality. Not unexpectedly, a few of them sud")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("denly flushed and abruptly turned their attention elsewhere, away from him.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("If only his reputation had died with his departure!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Unfortunately, it had not, something brought home to him the moment he entered Almack’s upon his return. The unctuous smiles, the knowing smirks, the jests about locking away wives and sisters…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Ten years ago, he had been the most pompous, lascivious cad imaginable, a man who entered into and ended liaisons at a whim, or as if he were at the mercy of his lust and had no more morals than a dumb beast—until the night that had forever changed his life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I confess I cannot understand why you have lived abroad for the past ten years,” Eloise declared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Galen was extremely tempted to say it was because he preferred Italian peasants to his family and the British aristocracy in general, but he did not. After all, he was Eloise’s guest, and no one was holding a gun to his head to force him to stay. “Because I like it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Obviously offended by his cavalier response, Eloise said, “Perhaps you should have stayed there, then.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I would have, if my father had not died.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("Eloise reddened, and to lessen her embarrass")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("ment, he continued in the same casual tone. “So I have returned. However, dear cousin, you have not asked me why I have stayed.”")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You have to run the estate,” Eloise replied. “Or there is a woman, I suppose.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“No, I do not have to run the estate. Jasper can do that without my personal interference,” Galen answered, naming the estate steward.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He moved closer to Eloise and dropped his voice to a conspiratorial whisper. “But you are right. There "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" a woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Eloise’s eyes widened with avid curiosity as he hesitated melodramatically. “I have decided to find a bride.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Eloise stared in amazement. “A…a what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“A bride. A wife. A spouse with whom to share the remainder of my days, and incidentally provide an heir. I have come home to get married.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I don’t believe…I cannot comprehend…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("His brow furrowed with grave concern. “Shall I call a footman for a glass of water or smelling salts, Eloise? You seem on the verge of a fainting spell.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“No! No! I am not ill. I am shocked! Surprised! Delighted! Married! You!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Although she ostensibly addressed him, her gaze eagerly searched the room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("“I have it!” she cried as if she had discovered El Dorado. With her fan she surreptitiously ges")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("tured toward a young woman in a gown of virginal white with a pink sash and pink tea roses in her glossy black hair. Her complexion was pink and white, too, and she had a long, graceful neck adorned with a relatively plain, thin gold chain.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Eloise’s voice dropped to an excited whisper. “Lady Mary, the Earl of Pillsborough’s daughter! Her fortune is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("immense.")]), _vm._v(" You could do much worse, Galen, much, much worse, for as you see, she is a beauty, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A beauty, perhaps, he inwardly agreed, yet he had seen many beauties, and it would take more than physical appeal to persuade him to marry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“She’s very accomplished, too. She plays and sings and nets the most exquisite reticules—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He interrupted Eloise before she had him engaged. “I was not planning on making a selection today.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Eloise frowned. “It’s not as if you are young, you know, Galen. You’re over thirty.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I know I have wasted quite enough time, Eloise, but I had my reasons.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Oh?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Private and personal reasons, cousin.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Eloise’s frown deepened. “Oh.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("“I do stand in serious need of your superior knowledge of the ton, however,” Galen said, not only because he did, but to placate her wounded ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("feelings. “I wouldn’t want to be carried away by a pretty face or charming manner.”")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Appeased, Eloise smiled. “I shall be delighted to be of assistance, Galen, delighted!” Then she frowned again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“What is it? Is there someone unsuitable here possessing a pretty face and charming manner? How pretty and how charming, and in what way unsuitable?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“As a matter of fact, yes—not for the reasons you might think, or reasons you might hear from other people.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“My dear cousin, you have me all agog with curiosity,” Galen replied, only slightly exaggerating.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“She’s a very dear friend of mine from my school days.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Galen could remember the younger Eloise. What a giggly creature she had been, and if her “very dear friend” was similar, Eloise’s warning was quite unnecessary.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“She’s a widow. Her husband passed away two years ago and she’s been practically a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hermit")]), _vm._v(" since it happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Galen made a wry smile. “It was my understanding, cousin, that hermits are all men.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Her fan fluttering about as if she were fending off an attack of moths, Eloise gave him a sour ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("look. “Recluse, then. Whatever you wish to call it, it’s taken this long for her to come for a visit.”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I don’t see any women wearing black,” he observed after a quick scan of the bevy of silk-and-satin-clad ladies.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“She isn’t here yet,” Eloise replied. “She should be down shortly, unless her daughter has made some sort of fuss. She simply dotes on the child and will spoil her completely if she’s not careful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Galen’s smile tightened imperceptibly. “I trust you have given her the benefit of your advice,” he remarked. Eloise’s opinions were very decided for a woman who had never been a mother.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Naturally, but I doubt she will pay any heed. She was always stubborn.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Then relax anew, cousin. I make it a policy to avoid stubborn women, and stubborn widows with children fill me with horror.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Please don’t talk like that around my friend! You’ll scandalize her, I’m sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“We wouldn’t want any of your guests scandalized,” Galen agreed, thinking how much it would take to truly scandalize most of them. “So, once we are introduced, I will ignore her,” he said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("His slight sarcasm was utterly lost on Eloise. “I know I can’t expect that. Everybody knows you can’t leave a pretty woman alone. Just don’t flirt with her, or I’m sure that will send her scurrying ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("back to Jefford as quick as a wink. She "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("has")]), _vm._v(" heard about you, you know. Indeed, I fear…” Eloise flushed. “Well, I may have painted a rather…vivid…portrait of you.”")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Galen could easily imagine how Eloise had described him and his activities before he left England. The widow would likely expect him to have horns and a tail.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Mind you, she isn’t as pretty as she used to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Her husband’s death had a serious effect on her looks?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“She was quite undone by it. Frankly, I thought he was rather old for her. Still, he adored her, people say, and was delirious with joy when they had a child, even if it was not a son.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Eloise shifted closer, unfortunately bringing the heavy scent of her perfume with her. “Her in-laws were furious, I understand. For years they were quite certain they were going to get the old man’s money, you see, and then not only does he marry, but along comes a child. The principal of his estate went to her. Her mother has an allowance from the interest. The in-laws only got a small bequest. Indeed, I heard tell they were quite nasty when Daniel Davis-Jones died, and even suggested an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("inquest")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Was his death so mysterious?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("“Well…” Eloise leaned even closer. “It was ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("rather sudden. Nevertheless, the doctor was absolutely sure it was pneumonia. How anybody could "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("think")]), _vm._v(" his wife could be capable of…” She raised her brows suggestively.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Murder?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Don’t say that!” Eloise cried, truly horrified. “You won’t consider it, either, after you meet her. She’s the most gentle creature!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You are the one putting such thoughts in my head,” Galen observed. “However do you learn these things?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I have my ways, Galen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Of course she did. She gave parties, had house-guests nearly continuously, took the waters at Bath and Baden-Baden and wrote letters. She had a network of gossiping friends that would likely put the government to shame when it came to gathering information.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Oh, dear, I think I’ve made a serious mistake,” Eloise said with as much remorse as he had ever heard her express. “You sound fascinated.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Ancient gossip really doesn’t interest me, and I assure you, cousin, that widows with children and no large estate hold absolutely no allure.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Good. Now come along and let me introduce you to Lady Mary,” Eloise said, nodding at the young lady across the room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("“I think I need a moment to compose myself before this important introduction,” he answered, ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("telling a partial truth. “If you’ll excuse me, I believe a brief turn around your lovely gardens will be just the thing.”")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Before Eloise could protest, Galen turned and strode out onto the terrace. A swift glance over his shoulder told him Eloise had not followed, and he sighed with relief.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He did welcome the fresh air, away from the scent of perfume and pomander and wig powder, for some of Eloise’s older guests still favored wigs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He should have known better than to take Eloise up on her invitation to stay at Potterton Abbey anytime he found it convenient. He had forgotten that she would consider her house empty if she had anything less than twenty guests.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("And now that he had told his voluble cousin his plan, he felt as if he might as well have set himself up for auction. Somebody should hang a placard around his neck reading, “For Sale, One Duke, in slightly used condition.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He paused a moment and slowly surveyed Eloise’s garden. She was a gossiping, usually harmless busybody, but she did have beautiful gardens. He inhaled deeply, encountering some scents that were universal, like the damp greenery, and others—ephemeral and unnameable—that told him he was in England.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Was there any green anywhere that could compare with the English countryside?")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("With another sigh, he headed toward the shrubbery. In theory, the bushes were supposed to represent untrammeled nature. Eloise, however, would no more allow nature to run wild within her domain than she would allow her husband to get a word in edgewise during a game of whist.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Still, a shrubbery was a shrubbery, which meant he could count on some privacy. If he was avoiding company in a way that could almost be termed hiding, he really didn’t care.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Sir!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Alerted by the warning cry, Galen ducked as some kind of missile flew past his head. “What in—!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I’m sorry!” a little girl called as she ran toward him from the shrubbery. She picked up her ball and paused awkwardly, blushing and regarding him with brilliantly blue eyes beneath a riot of dark curls. “I didn’t know anybody was nearby when I kicked it,” she continued in soft and sorry tones.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She could have been any age from eight, if she were tall for her age, to twelve, if she were short. She was well dressed in a dark garment devoid of ornamentation, which bespoke mourning, and made of fine enough fabric that he guessed she was the child of one of Eloise’s many guests.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("His heart went out to a child who had cause to wear mourning clothes, especially this sprite of a girl whose bright eyes made him think she really ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("ought to be wearing something pastel and decorated with flowers.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Then he wondered if this was the daughter of Eloise’s bereaved friend, the stubborn widow who had lost her looks.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("If that was so, Eloise was wrong in her estimation that the girl was spoiled. He had very intimate knowledge of spoiled brats, and this child didn’t fit the mold. His youngest half brother would have chastised him for getting in the way without a moment’s hesitation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“That’s quite all right,” he assured her, giving her a smile. Galen Bromney’s smiles were not particularly rare; however, a sincere smile on his face was. “I’m glad to know I was not under attack.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The girl’s eyes widened as she clutched her ball close. “Have you ever been under attack?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Once or twice,” Galen replied ruefully.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The girl’s mouth formed an awestruck circle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“At the risk to my reputation, and to be completely honest,” Galen confessed, “the weapon was words, not a sword.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The child’s face fell and quite suddenly Galen felt the most outrageous sense of loss. “Allow me to introduce myself. I am the Duke of Deighton,” he said formally, making his very best bow.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("He was absurdly pleased to see the awe return to her blue eyes as she made a graceful little curtsy. ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("“I am Miss Jocelyn Davis-Jones,” she replied gravely.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“How do you do, Miss Davis-Jones?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Very well, thank you, Your Grace.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He was impressed that she knew the proper form of address. “Are you all by yourself?” he asked, looking around for other children.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Yes,” she said in a tone that was both hurt and defiant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She must have seen the puzzlement in his face. “They didn’t want to come outside, so I came by myself. I don’t mind being alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Admirable independence, Miss Davis-Jones.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I would rather be at home. I don’t like it here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I am sorry to hear that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The child flushed. “Lady Bodenham is very nice, and her house is wonderful, and her cook makes lovely puddings, but I miss my own house.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I do, too,” Galen confessed. “My house is in Italy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Her brows furrowed. “Are you Italian?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He shook his head. “No, but I have lived in Italy for the past ten years, and I think of it as my home.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Indeed, his villa was more of a home than his family’s seat had ever been, even if it could be just as lonely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Oh. I suppose I had better go in for tea now.”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I don’t think it’s quite time yet,” Galen said. He nodded at the ball in her hands. “I haven’t played football for a very long time. Would you like to play a game?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Jocelyn Davis-Jones tilted her head and scrutinized him skeptically. As she did, he realized he wanted this child to like him, although he couldn’t say why.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You might get your clothes messy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Galen suspected this warning had been given to her many times. “I am willing to accept the consequences,” he declared bravely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He was rewarded with a smile before the girl put the ball on the ground. While Galen wondered if her bountiful curls were natural, she suddenly—and without a word of warning—kicked the ball directly at him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("With a dexterous leap, he eluded it, then scrambled to catch the ball with his foot. He kicked it back toward Jocelyn while he crouched down in anticipation of the next kick, regardless of the crease of his trousers or what his valet might say.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The little girl was fast, and soon had the ball between her feet. In another instant, it came flying along the ground toward Galen, who threw out his leg in a wild and foolish attempt to stop it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("With a roar of dismay and not a little pain, he fell to the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Are you hurt?” Jocelyn cried worriedly.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“No,” Galen muttered as he grabbed the ball and got back on his feet as fast as his thirty-year-old legs and one slightly pulled muscle would let him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He held the ball out, dropped it and caught it midair with a kick. With a bleat like a lamb, she was after it and Galen took a moment to brush bits of greenery from his trousers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("At the sound of a foot colliding with the ball, he looked up, then dashed across the open space to intercept. He gave a cry of triumph as he returned the ball without having to bring the rolling object to a complete stop.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The child ran the other way to catch it, but before she could, it disappeared under a particularly bushy shrub. Bending over, she peered under it. “I can’t see where it went!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Galen hurried to help her look for it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("They were both bent over and scanning the thick trunks and branches of the smoothly pruned bushes when they heard a woman calling Jocelyn’s name.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("His companion straightened. “That’s my mama. It must be time for tea.” She glanced worriedly at the bushes that had apparently swallowed up her toy. “She’ll be upset if I’ve lost my ball.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Then I shall stay and look for it,” Galen offered. “I’m sure it can’t be far—although I did give it a prodigious kick.”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“It was a crocked kick, or I would have caught it,” Jocelyn declared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“It went exactly where I meant it to go. Or rather, in the right direction,” Galen replied defensively.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Jocelyn’s expression betrayed her dubiousness. “You wanted it to disappear in the bushes?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“No, of course not. I was aiming for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“But I was way over there!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Well…” Galen had to laugh. “Very well, my aim was off—but you were moving in this direction, weren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Jocelyn?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Galen and his little friend both turned to find a young woman looking at them quizzically.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Verity Escombe")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("At the sight of her instantly recognized face, a host of emotions shot through Galen—of joy, dismay, anger and excitement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He took a step forward, then caught himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He had never wanted to see her again. During these past ten years, he had hoped he would never see her again. Good God, why did he have to see her again?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("It had been ten years, yet Verity Escombe was much the same, with those questioning blue eyes that her daughter had inherited and her lips parted as if about to ask a question, or in anticipation of his kiss.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He noted her gown of plain black, with a high waist in the fashion of the day. A thin black lace shawl covered her slender shoulders. Her light brown hair was simply and plainly dressed, and she wore no gloves.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He looked at her left hand and saw the wedding ring.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Mama, this is the Duke of Deighton,” Jocelyn announced, hurrying forward and taking her mother by the hand to lead her toward him. “We’ve been playing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He glanced at the child. No matter how he felt about Verity, he wouldn’t hurt her little girl by being rude, so he bowed elegantly and spoke as if he had never met Verity Escombe before.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("As if, ten years ago, she had not seduced and abandoned him.")])])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page23"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fae3421","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dukesdesirethe_ch01.vue
// module id = 75
// module chunks = 0